import React from 'react';
import Select, { components } from 'react-select';
import { useTheme } from '../../theme-context';

interface ISelectCheckbox {
    ref?: any;
    options: Array<any>;
    selectedOption?: string | string[] | any;
    onChangeSelectedOption: (e: any, type?: string, index?: any, parent?: any) => void;
    multiple?: boolean;
    placeholder?: string;
    error?: string;
    selectStyle?: any;
    placeholderStyle?: any;
    singleValueStyle?: any;
    dropDownIndicatorStyle?: any;
    indicatorSeparatorStyle?: any;
    containerStyle?: string;
    uniqueName?: string;
    name?: string;
    isLoading?: boolean;
    disabled?: boolean;
    index?: any;
    loadingOptions?: boolean;
    dynamicOptions?: boolean;
    showFixed?: boolean;
    dataQa?: string;
    parent?: any;
    onHandleKeyDown?: (e: any, type?: string, index?: any, parent?: any) => void;
    onChangeValue?: (e: any, type?: string, index?: any, parent?: any) => void;
    onMenuClose?: (type?: string, index?: any, parent?: any) => void;
}

const SelectCheckbox = ({
    ref,
    options,
    parent,
    selectedOption,
    multiple,
    placeholder,
    error,
    containerStyle,
    selectStyle,
    indicatorSeparatorStyle,
    dropDownIndicatorStyle,
    placeholderStyle,
    singleValueStyle,
    uniqueName,
    name,
    isLoading,
    showFixed,
    dataQa,
    index,
    loadingOptions,
    disabled,
    dynamicOptions,
    onChangeSelectedOption,
    onChangeValue,
    onMenuClose,
    onHandleKeyDown
}: ISelectCheckbox) => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    const customStyles = {
        control: (base: any, state: any) => ({
            ...base,
            backgroundColor: isDark ? '#000' : '#ffffff',
            color: isDark ? '#ffffff' : '#000000',
            borderColor: error ? 'red' : (isDark ? '#374151' : '#e5e7eb'),
            boxShadow: 'none',
            paddingTop: 2,
            paddingBottom: 2,
            '&:hover': {
                borderColor: isDark ? '#4b5563' : '#d1d5db',
                cursor: 'pointer'
            },
            ...selectStyle || {}
        }),
        menu: (base: any) => ({
            ...base,
            backgroundColor: isDark ? '#000' : '#ffffff',
            color: isDark ? '#ffffff' : '#000000',
            maxHeight: 130,
            minWidth: 120
        }),
        menuList: (base: any) => ({
            ...base,
            maxHeight: 130,
        }),
        menuPortal: (base: any) => ({
            ...base,
            zIndex: 9999,
        }),
        option: (base: any, { isFocused, isSelected }: any) => ({
            ...base,
            backgroundColor: isSelected
                ? (isDark ? '#4b5563' : '#e5e7eb')
                : isFocused
                    ? (isDark ? '#374151' : '#f3f4f6')
                    : 'transparent',
            color: isDark ? '#ffffff' : '#000000',
            cursor: 'pointer'
        }),
        singleValue: (base: any) => ({
            ...base,
            color: isDark ? '#ffffff' : '#000000',
            ...singleValueStyle || {}
        }),
        placeholder: (base: any) => ({
            ...base,
            color: isDark ? '#9ca3af' : '#6b7280',
            ...placeholderStyle || {}
        }),
        indicatorSeparator: (base: any) => ({
            ...base,
            backgroundColor: isDark ? '#4b5563' : '#e5e7eb',
            ...indicatorSeparatorStyle || {}
        }),
        dropdownIndicator: (base: any) => ({
            ...base,
            color: isDark ? '#ffffff' : '#6b7280',
            ...dropDownIndicatorStyle || {}
        }),
    };

    const Input = (props: any) => {
        return <components.Input {...props} data-qa={dataQa || ''} />;
    };

    return (
        <div className={`checkbox-select ${containerStyle || 'mb-3 w-full'}`}>
            {name && <p className='mb-1 text-gray-500 dark:text-gray-300'>{name}</p>}
            <Select
                ref={ref}
                menuPosition={showFixed ? 'fixed' : 'absolute'}
                placeholder={placeholder}
                menuPortalTarget={document.body}
                value={selectedOption || null}
                onChange={(e) => onChangeSelectedOption(e, uniqueName, index, parent)}
                options={loadingOptions ? [] : options || []}
                styles={customStyles}
                components={{ Input }}
                noOptionsMessage={() => loadingOptions ? 'Loading...' : 'No Options'}
                onInputChange={(e) => onChangeValue?.(e, uniqueName, index, parent)}
                isDisabled={isLoading || disabled || false}
                isLoading={isLoading || false}
                isSearchable={options?.length > 0 || dynamicOptions}
                isMulti={multiple || false}
                onKeyDown={(e) => onHandleKeyDown?.(e, uniqueName, index, parent)}
                onMenuClose={() => onMenuClose?.(uniqueName, index, parent)} />
            {error ? (
                <span className='block text-xs text-red-500'>{error}</span>
            ) : (
                <span className='block' />
            )}
        </div>
    );
};

export default SelectCheckbox;
